module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"Отмена":"Cancel","Продолжить":"Continue","Ранее вы начинали заполнять эту форму.":"You have previously started filling out this form.","Продолжить заполнение или начать с чистого листа?":"Continue filling out or start from scratch?"}}')
  delete Component.options._Ctor
}
